import(/* webpackMode: "eager", webpackExports: ["MarketingPawWalkIcon","MarketingPlayConnectionsIcon"] */ "/app/components/landing/MarketingDogIcons.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
